exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.privacyPolicyBox[data-v-d55a7ab4]{padding:16px 8px 50px 8px;white-space:normal;word-break:break-all;color:#666666;text-align:justify;text-justify:inter-ideograph\n}\n", ""]);

// exports
